import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6be136b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, " 마케팅 정보 수신 동의 안내 ", -1))
const _hoisted_3 = { class: "subtitle" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 테라사이클의 재활용 소식 및 정보를 받아 보시기를 원하신다면 아래 내용을 ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 확인하시고 동의해 주세요. ")
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"table-wrapper\" data-v-6be136b9><div class=\"item\" data-v-6be136b9><div class=\"label\" data-v-6be136b9> 항목 </div><div class=\"value\" data-v-6be136b9> 마케팅 정보 수신 동의 </div></div><div class=\"item\" data-v-6be136b9><div class=\"label\" data-v-6be136b9> 이용 목적 </div><div class=\"value\" data-v-6be136b9> 새로운 신규 캠페인 및 이벤트 정보 등 안내 </div></div><div class=\"item\" data-v-6be136b9><div class=\"label\" data-v-6be136b9> 보유 기간 </div><div class=\"value\" data-v-6be136b9> 별도 동의 철회시까지 또는 약관 철회 후 2주일까지 </div></div></div>", 1)
const _hoisted_9 = { class: "tips" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 해당 내용은 마이페이지에서 언제든지 동의 철회가 가능합니다. ", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 마이페이지 바로가기 ")

import { authStore } from '@/stores';
import { computed, onMounted } from 'vue';
import _ from 'lodash';
import { request, alert } from '@/utils';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const { t } = useI18n();
const name = computed(() => _.get(authStore.user, 'profile.nick_name') || 'nickname');

onMounted(async () => {
  await authStore.tryFetchData();
  if (authStore.user?.subscribe_tc_information) {
    router.replace({ name: 'mine.memberProfile' });
  }
});

async function handleSubscribe() {
  const { data } = await request.put('/mine', {
    subscribe_tc_information: true
  });
  authStore.user = data;
  await alert({ title: t('Success'), content: t('Operation success'), });
  router.replace({ name: 'mine.memberProfile' });
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(name))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(" 안녕하세요, (" + _toDisplayString(_unref(name)) + ")님! ", 1),
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7
        ]),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_router_link, {
            class: "tag-text",
            to: "/mine"
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: "button",
          onClick: handleSubscribe
        }, " 동의합니다 ")
      ]))
    : _createCommentVNode("", true)
}
}

})